export default __webpack_public_path__ + "static/media/react-logo-transparent.c39e9569.svg";